import React, { FC } from 'react'

import { IconTetheringProps } from './IconTethering.types'
import * as Styled from './styles/IconTethering.style'

import { nonThemeableRules } from '../../ruleSet'

const IconTethering: FC<IconTetheringProps> = ({
  size = nonThemeableRules.defaultSize as number as IconTetheringProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconTetheringProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M136.79 23.65A79.47 79.47 0 0 0 80.31 0H80a80 80 0 0 0-56.79 136.35 4 4 0 1 0 5.68-5.63A72 72 0 0 1 80 8h.29a72 72 0 0 1 50.67 122.87 4 4 0 0 0 5.66 5.65 80.17 80.17 0 0 0 .17-112.87z' />
        <path d='M119.58 40.34A55.63 55.63 0 0 0 80 24a56 56 0 0 0-39.55 95.62 4 4 0 0 0 5.65-5.66A48 48 0 0 1 80 32a48 48 0 0 1 34 81.84 4 4 0 0 0 5.67 5.64 56.09 56.09 0 0 0-.09-79.14z' />
        <path d='M57.41 57.36a32 32 0 0 0 0 45.25A4 4 0 1 0 63 97a24 24 0 1 1 34.29-.33 4 4 0 0 0 5.77 5.54 32 32 0 0 0-45.65-44.85z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconTethering
